import { parseISO, format, isValid } from "date-fns";

/**
 * parseISO seguro que não quebra com datas inválidas
 * @param {string} dateStr - String da data para fazer parse
 * @returns {Date|null} - Data parseada ou null se inválida
 */
export const safeParse = (dateStr) => {
  if (!dateStr || dateStr === "Invalid Date") return null;
  try {
    const parsed = parseISO(dateStr);
    return isValid(parsed) ? parsed : null;
  } catch {
    return null;
  }
};

/**
 * format seguro que retorna fallback se data inválida
 * @param {string} dateStr - String da data para formatar
 * @param {string} formatStr - Formato desejado (ex: "dd/MM/yyyy")
 * @param {object} options - Opções do date-fns (ex: { locale: pt })
 * @returns {string} - Data formatada ou "N/A" se inválida
 */
export const safeFormat = (dateStr, formatStr, options = {}) => {
  const parsed = safeParse(dateStr);
  return parsed ? format(parsed, formatStr, options) : "N/A";
};
